import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { prettyLetter } from 'pretty-letters';

gsap.registerPlugin(ScrollTrigger);

export default class Footer {
    constructor(){
        this.page = {
            title: document.getElementById('page-title'),
            header: document.querySelector('header.header'),
            company: document.getElementById('company'),
        }

        this.menu = document.getElementById('menu-toggler'),

        this.footer = {
            el: document.querySelector('footer'),
            content: document.querySelectorAll('footer h6'),
        };

        this.section = {
            last: document.querySelector('section:last-of-type'),
        };
    }

    init(){
        console.log(this.section.last);
        this.set();
        this.animation();
    }

    set = () => {
        gsap.set(this.footer.content, {
            autoAlpha: 0,
        });
    }

    animation = () => {
        gsap.to(this.footer.content, 2,{
            autoAlpha: 1,
            delay: .5,
            stagger: .05,
            ease: 'expo.easeInOut',
            scrollTrigger: {
                trigger: this.section.last,
                start: 'bottom 100%-=20',
                end: 'bottom 100%',
                toggleActions: 'play none play reverse',
            }
        });

        gsap.to(this.footer.content, {
            scrollTrigger: {
                trigger: this.footer.content,
                start: 'top bottom',
                end: 'bottom bottom',
                onEnter: () => {
                    this.page.company.classList.contains('visible') ? null : this.page.company.classList.add('visible');
                },
                onLeaveBack: () => { 
                    this.menu.classList.contains('active') ? null : this.page.company.classList.remove('visible');
                },
            }
        });
    }
}
